import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/forbidden')({
  component: ForbiddenPage,
});

function ForbiddenPage() {
  return (
    <div className="min-h-screen grid place-items-center p-8">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold">Kein Zugriff</h1>
        <p className="text-muted-foreground">Dieser Bereich ist für deine Rolle nicht freigegeben.</p>
        <Link to="/" className="underline text-[oklch(0.7_0.04_195)]">
          Zur Startseite
        </Link>
      </div>
    </div>
  );
}
